
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import AnimationFactory from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import GameStatus from "../model/GameStatus";
import SaveModel from "../model/SaveModel";
import AbstractAccuracyScreenMediator from "./AbstractAccuracyScreenMediator";
import GameElementSkinFactory from "./GameElementSkinFactory";
import HudView from "./HudView";
import GoalBoxView from "./GoalBoxView";
import ItemPoolView from "./ItemPoolView";
import ExampleBoxView from "./ExampleBoxView";
import SlotEvent from "./SlotEvent";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class GameScreenMediator extends AbstractAccuracyScreenMediator {

    /**
     * @param {*} target 
     * @param {*} dispatcher 
     * @param {*} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {GameModel} gameModel 
     * @param {GameConfig} gameConfig 
     * @param {RoadBuilder} roadBuilder 
     * @param {Object} roadAssets 
     * @param {SaveModel} saveModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, gameConfig, saveModel, gameAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets);
        this._gameConfig = gameConfig;

        this._handleTickBound = this._handleTick.bind(this);
        this._handleGameModelStatusBound = this._handleGameModelStatus.bind(this);
        this._handleGameModelPuzzleBound = this._handleGameModelPuzzle.bind(this);
        this._handleGameModelScoreBound = this._handleGameModelScore.bind(this);
        this._handleGameModelElapsedTimeBound = this._handleGameModelElapsedTime.bind(this);
    }

    initialize() {
        super.initialize();

        this.anchorObject(this._target.hud, Anchor.T);

        const elementFactory = new GameElementSkinFactory(this._gameConfig, this._gameAssets);
        this._hud = new HudView(this._target.hud, this._target.time, this._target.boxScore, this._languagePack);
        this._itemPool = new ItemPoolView(this._target.itemPool, elementFactory, getURLParameter("wrap") == 1);
        this._itemPool.addEventListener(SlotEvent.SELECTED, this._handleItemPoolSlotSelected.bind(this));
        this._goalBox = new GoalBoxView(this._target.box, elementFactory);
        this._goalBox.addEventListener(SlotEvent.SELECTED, this._handleBoxSlotSelected.bind(this));
        this._exampleBox = new ExampleBoxView(this._target.example, elementFactory);

        this._handleDoneClick = this._handleDoneClick.bind(this);
        this._buttonSubmit = this.createButton(this._target.button, this._handleDoneClick, this.getText("game.buttonSubmit"));
        this._buttonSubmit.setEnabled(false);

        this._initializeDebug();

        this._addEventListeners();

        const saveGame = this._saveModel.getSaveGame();
        this._reset(saveGame);

        // if (!saveGame && getURLParameter("skiptutorial") != "1") {
        //     this._startTutorial();
        // } else {
        //     const delay = this.checkSavegameRestoredFeedback(500) ? 1500 : 0;
        //     this.callDelayed(this._handleTutorialClose.bind(this), delay);
        // }
        this._hud.setScore(0);//TEMP?
        this._hud.setTime(this._gameModel.remainingTime);

        if (!saveGame && getURLParameter("skiptutorial") != "1") {
            this._startTutorial();
        } else {
            this._startGame();
        }
    }

    destroy() {
        super.destroy();
        this._removeEventListeners();
        if (window.gamescreen == this) {
            window.gamescreen = null;
        }
    }

    _addEventListeners() {
        this._gameModel.addEventListener(GameModel.STATUS, this._handleGameModelStatusBound);
        this._gameModel.addEventListener(GameModel.PUZZLE, this._handleGameModelPuzzleBound);
        this._gameModel.addEventListener(GameModel.SCORE, this._handleGameModelScoreBound);
        this._gameModel.addEventListener(GameModel.ELAPSED_TIME, this._handleGameModelElapsedTimeBound);
    }
    _removeEventListeners() {
        this._gameModel.removeEventListener(GameModel.STATUS, this._handleGameModelStatusBound);
        this._gameModel.removeEventListener(GameModel.PUZZLE, this._handleGameModelPuzzleBound);
        this._gameModel.removeEventListener(GameModel.SCORE, this._handleGameModelScoreBound);
        this._gameModel.removeEventListener(GameModel.ELAPSED_TIME, this._handleGameModelElapsedTimeBound);
    }

    _handleGameModelPuzzle() {
        this._hud.setPuzzleIndex(this._gameModel.puzzleIndex);
        this._hud.setScore(this._gameModel.score);
        const puzzle = this._gameModel.puzzle;
        this._goalBox.setSize(puzzle.goal.length);
        this._exampleBox.setSize(puzzle.goal.length);
        this._exampleBox.fill(puzzle.goal);
        this._itemPool.setPool(puzzle.items);
        this._goalBox.enabled = true;
        this._itemPool.enabled = true;
        this._updateBox();
    }

    _handleGameModelScore() {
        this._hud.setScore(this._gameModel.score);
    }

    _handleGameModelStatus({ data: status }) {
        switch (status) {
            case GameStatus.TIMEOUT:
                this._stopTicker();
                this.showPopupForPrefix("game.timeout", _ => this.gotoScreen(SkinKeys.END_SCREEN));
                break;
            case GameStatus.END:
                this._stopTicker();
                this.gotoScreen(SkinKeys.END_SCREEN);
                break;
        }
    }

    _handleGameModelElapsedTime() {
        this._hud.setTime(this._gameModel.remainingTime);
    }


    _reset(snapshot) {
        this._stopTicker();
        // if (snapshot && snapshot.status == GameStatus.RUNNING) {
        //     this._gameModel.applySnapshot(snapshot, true);
        // } else {
        this._gameModel.reset();
        // }
    }

    _startTicker() {
        this._tickTime = performance.now();
        this._target.stage.addEventListener("tick", this._handleTickBound);
    }
    _stopTicker() {
        this._target.stage.removeEventListener("tick", this._handleTickBound);
    }
    _handleTick() {
        if (!this._paused) {
            const now = performance.now();
            const delta = now - this._tickTime;
            this._tickTime = now;
            this._gameModel.step(delta);
        }
    }


    _startGame() {
        this._doNextPuzzle();
        this._gameModel.start();
        this.callDelayed(this._startTicker.bind(this), 1000);
    }

    _doNextPuzzle() {
        if (this._gameModel.hasNextPuzzle()) {
            this._gameModel.doNextPuzzle();
        } else {
            this.gotoScreen(SkinKeys.END_SCREEN);
        }
    }


    /*******************************
     *     PUZZLE INTERACTION
     *******************************/


    _handleItemPoolSlotSelected(e) {
        /**@type {ItemSlotView} */
        const slot = e.data;
        if (slot) {
            this._checkFillBoxSlot();
            this._updateBox();
        }
    }

    _handleBoxSlotSelected(e) {
        /**@type {ItemSlotView} */
        const slot = e.data;
        if (slot) {
            //if slot was filled, empty it
            const puzzle = this._gameModel.puzzle;
            const itemId = puzzle.getItemInSlot(slot.index);
            if (!isNull(itemId)) {
                puzzle.clearSlot(slot.index);
            }
            this._checkFillBoxSlot();
            this._updateBox();
        }

    }

    _handleDoneClick() {
        if (getURLParameter("confirm")!="1") {
            this._submitPuzzle();
        } else {
            this.showPopupForPrefix("game.confirmSubmit", this._submitPuzzle.bind(this));
        }
    }

    _submitPuzzle() {
        this._gameModel.submitPuzzle();
        this._doNextPuzzle();
    }

    _checkFillBoxSlot() {
        if (this._itemPool.selectedSlot && this._goalBox.selectedSlot) {
            const itemId = this._itemPool.selectedSlot.itemId;
            const index = this._goalBox.selectedSlot.index;
            const puzzle = this._gameModel.puzzle;
            puzzle.fillSlot(index, itemId);

            this._goalBox.unselect();
            this._itemPool.unselect();
        }
    }

    _updateBox() {
        const puzzle = this._gameModel.puzzle;
        puzzle.slots.forEach((itemId, index) => {
            this._goalBox.fillSlot(index, itemId);
        });
        const enabled = puzzle.slots.some(itemId => itemId != null) || getURLParameter("submitenabled") == "1";
        this._buttonSubmit.setEnabled(enabled);
        this._hud.setPuzzleScore(puzzle.score);
    }


    /********************
     *     GENERIC
     ********************/

    showPopupForPrefix(prefix, callbackOk, callbackCancel) {
        const title = this.getText(`${prefix}.title`);
        const body = this.getText(`${prefix}.body`);
        const buttonParams = [];
        const ok = this.getText(`${prefix}.ok`);
        if (ok) {
            buttonParams.push({ label: ok, callback: callbackOk });
        }
        const cancel = this.getText(`${prefix}.cancel`);
        if (cancel) {
            buttonParams.push({ label: cancel, callback: callbackCancel });
        }

        this.showPopup(title, body, buttonParams);
    }


    /********************
     *     TUTORIAL
     ********************/

    _startTutorial() {
        this._gameModel.initTutorialPuzzle();
        this._goalBox.enabled = false;
        this._itemPool.enabled = false;
        this._updateBox();
        this._hud.setPuzzleIndex(2);
        this._hud.setScore(.67);
        this._buttonSubmit.setEnabled(true);
        const delay = this._gameConfig.getValue("tutorial.delay");
        const duration = this._gameConfig.getValue("tutorial.fadeDuration");
        const options = new AnimationOptions(delay, duration, createjs.Ease.quadIn);
        this.openPopup(SkinKeys.TUTORIAL_OVERLAY_SKIN, this._handleTutorialClose.bind(this), AnimationFactory.FADE_IN, options);
    }

    _handleTutorialClose() {
        this._hud.setPuzzleIndex(0);
        this._hud.setScore(0);
        this._hud.setPuzzleScore(0);
        this._goalBox.clear();
        this.callDelayed(this._startGame.bind(this), 1000);
    }



    /********************
     *     DEBUG
     ********************/

    _initializeDebug() {
        if (ranj.DEBUG) {
            window.document.addEventListener('keyup', e => {
                const c = String.fromCharCode(e.which);
                //console.log(c, e.code, e.which);
                if (c == "P") {
                    this._paused = !this._paused;
                    if (!this._paused) {
                        this._tickTime = performance.now();
                    }
                } else if (c == "E") {
                    this.gotoScreen(SkinKeys.END_SCREEN);
                } else if (c == "T") {
                    this._gameModel.step(this._gameModel.remainingTime - 1000);
                } else if (c == "C") {
                    this._gameModel._puzzleIndex--;
                    this._doNextPuzzle();
                } else if (c == "F") {
                    this._gameModel.puzzle.fill(this._gameModel.puzzle.goal);
                    this._updateBox();
                } else if (e.which == 37) {
                    this._gameModel._puzzleIndex = Math.max(-1, this._gameModel._puzzleIndex - 2);
                    this._doNextPuzzle();
                } else if (e.which == 39) {
                    this._gameModel.doNextPuzzle();
                }
            });
            window.gamescreen = this;//for console access
        }
    }

}
